import api from './index';

export const apiGetTagsAndServicesByCity = async (company_id, city_id) => {
  try {
    const { data } = await api.get(`/partner/tags/services/${city_id}`);
    return data;
  } catch (error) {
    throw error;
  }
};

export const apiGetServicesByCategory = async (tag_id, city_id) => {
  try {
    const { data } = await api.get(`/partner/tag/${tag_id}/services/${city_id}`);
    return data;
  } catch (error) {
    throw error;
  }
};
